import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Styles from "./UnderConstruction.module.scss";
import PageUnderConstruction from "../../assets/images/PageUnderConstruction.png";

const UnderConstruction = () => {
  return (
    <Box>
      {/* Content */}
      <Stack className={Styles.Content}>
        <img
          src={PageUnderConstruction}
          alt="Page Under Construction"
          style={{ width: 147 }}
        />
        <Typography className={Styles.Welcome}>
          {/* Welcome {data?.contactName}! */}
        </Typography>
        <Typography
          style={{
            fontWeight: 600,
            fontSize: "22px",
            fontFamily: "Open Sans, sans-serif",
          }}
        >
          Page Under Construction
        </Typography>

        <Typography
          style={{
            fontWeight: 400,
            fontSize: "16px",
            alignItems: "center",
            color: "#000000",
            padding: "0px 20px",
            marginTop: "20px",
            fontFamily: "Open Sans, sans-serif",
          }}
        >
          We're working hard to bring you something awesome!
          <br />
          This page is currently under construction, but we'll be up and running
          soon.
        </Typography>
      </Stack>
    </Box>
  );
};

export default UnderConstruction;
